import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { projects } from '../mockData';

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-white relative">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Our <span className="text-brand-red">Projects</span>
          </h2>
          <p className="text-xl text-gray-600">
            Delivering excellence across diverse infrastructure and development projects
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Project Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                
                {/* Status Badge */}
                <div className="absolute top-4 right-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    project.status === 'Completed' 
                      ? 'bg-green-500 text-white' 
                      : project.status === 'In Progress'
                      ? 'bg-blue-500 text-white'
                      : 'bg-brand-red text-white'
                  }`}>
                    {project.status}
                  </span>
                </div>

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-brand-red/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <Link to="/projects" data-testid={`home-project-view-details-${project.id}`} className="bg-white text-brand-red px-6 py-3 rounded-lg font-semibold flex items-center space-x-2 transform scale-90 group-hover:scale-100 transition-transform">
                    <span>View Details</span>
                    <ExternalLink className="w-4 h-4" />
                  </Link>
                </div>
              </div>

              {/* Project Info */}
              <div className="p-6 bg-white">
                <div className="text-sm text-brand-red font-semibold mb-2">
                  {project.category}
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2 group-hover:text-brand-red transition-colors">
                  {project.name}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {project.description}
                </p>
                {project.role && (
                  <div className="mt-3 text-xs text-gray-500">
                    <span className="font-semibold text-charcoal">Role:</span> {project.role}
                    {project.mainContractor && <> · <span className="font-semibold text-charcoal">Main Contractor:</span> {project.mainContractor}</>}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
